import styled from 'styled-components';
import { Icon } from 'components/common/icon/icon';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { useMixpanel } from 'hooks';

const StyledButton = styled.button`
  position: relative;
  width: 1.7em;
  height: 1.7em;
  border-radius: 4px;
  font-size: 1.5em;
  padding: 0;

  &:active,
  &:focus,
  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }
  &[disabled],
  &[disabled]:hover,
  &[disabled]:focus {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }
`;

const LocalIcon = props => <Icon {...props} />;

const StyledIcon = styled(LocalIcon)`
  color: ${props => props.theme.colors.white};
  position: absolute;
  top: 0.3em;
  left: 0.3em;
`;

export const ClickableIcon = ({
  name,
  className,
  mixpanelProps,
  onClick,
  children,
  submit,
  buttonId,
  iconId,
  title,
  iconClassName,
  ...props
}) => {
  const { logToMixpanel, incrementPeople } = useMixpanel();
  const onClickAction = e => {
    if (onClick) {
      onClick(e);
    }
    if (mixpanelProps && mixpanelProps.object) {
      logToMixpanel(mixpanelProps.object);
    }
    if (mixpanelProps && mixpanelProps.people) {
      Array.isArray(mixpanelProps.people)
        ? mixpanelProps.people.forEach(peopleItem => incrementPeople(peopleItem))
        : incrementPeople(mixpanelProps.people);
    }
  };
  return (
    <StyledButton
      className={`${className} clickableIcon`}
      onClick={onClickAction}
      type={submit ? 'submit' : 'button'}
      id={buttonId}
      title={title}
      {...props}
    >
      <StyledIcon id={iconId} className={`icon ${iconClassName}`} name={name} {...props} />
      {children}
    </StyledButton>
  );
};

ClickableIcon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  mixpanelProps: PropTypes.object,
  onClick: PropTypes.func,
  children: PropTypes.node,
  submit: PropTypes.bool,
  buttonId: PropTypes.string,
  iconId: PropTypes.string,
  title: PropTypes.string,
  iconClassName: PropTypes.string
};

export default memo(ClickableIcon);
